import React from 'react';
import { Banner } from 'components/modules/modules.styles';
import { Container, Skeleton } from 'styles';

interface Props {
  color: string;
}

export const LoadingBanner = ({ color, ...rest }: Props) => (
  <Banner color={color} {...rest}>
    <Container margin={{ bottom: '32px' }}>
      <Skeleton
        data-testid="loading-banner"
        height="40px"
        opacity="uncharacteristicallyLow"
        variant="tertiary"
        width="80%"
        withShimmer
      />
    </Container>
    <Container>
      <Skeleton
        height="72px"
        margin={{ bottom: '24px', top: '8px' }}
        opacity="uncharacteristicallyLow"
        variant="tertiary"
        width="100%"
        withShimmer
      />
      <Skeleton
        height="72px"
        opacity="uncharacteristicallyLow"
        variant="tertiary"
        width="100%"
        withShimmer
      />
    </Container>
  </Banner>
);
